"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BedIconSmall = BedIconSmall;
exports.default = BedIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function BedIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M7 6.55752V8.69783C7.44647 8.82039 8.1239 8.9606 8.96149 8.96475C9.83765 8.96914 10.544 8.82303 11 8.69783V6.55752C10.5059 6.44027 9.79156 6.3179 8.9245 6.32534C8.13001 6.33218 7.47101 6.4457 7 6.55752Z",
    fill: "currentColor"
  }), (0, _core.jsx)("path", {
    d: "M13 8.69783V6.55752C13.471 6.4457 14.13 6.33218 14.9245 6.32534C15.7916 6.3179 16.5059 6.44027 17 6.55752V8.69783C16.544 8.82303 15.8376 8.96914 14.9615 8.96475C14.1239 8.9606 13.4465 8.82039 13 8.69783Z",
    fill: "currentColor"
  }), (0, _core.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.1843V2H3V10.1843C1.8385 10.5984 1 11.6981 1 13V19H3.52264L2.32263 22H4.47735L5.67736 19H18.3226L19.5226 22H21.6773L20.4773 19H23V13C23 11.6981 22.1615 10.5984 21 10.1843ZM5 4H19V10H5V4ZM21 17H3V13C3 12.4487 3.44873 12 4 12H20C20.5513 12 21 12.4487 21 13V17Z",
    fill: "currentColor"
  }));
}
function BedIconSmall(props) {
  return (0, _core.jsx)(BedIcon, _extends({
    size: "small"
  }, props));
}